import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
`;

export const FloatingBallContainer = styled.div<{ isClosing?: boolean }>`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 90px;
  height: 90px;
  border-radius: 53px;
  border: 2px solid #00D2DC;
  background: #EAF0F4;
  box-shadow: 0px 0px 34px 0px #00000073;
  cursor: pointer;
  transition: all 300ms ease-out;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${props => props.isClosing ? fadeOut : fadeIn} 0.3s ease-out forwards;

  @media (max-width: 600px) {
    right: 16px;
    bottom: 16px;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    transform: translateX(0);
    left: auto;
    margin: 0;
    max-width: calc(100vw - 32px);
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 33px;
  height: 33px;
  border-radius: 16.5px;
  border: 2px solid #00D2DC;
  background: #FDFDFD;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  z-index: 1001;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 300ms ease-out;

  &:hover {
    transform: scale(1.1);
  }
`;

export const CloseIcon = styled.div`
  width: 18px;
  height: 18px;
  position: relative;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 2px;
    background-color: #000000;
    top: 50%;
    left: 0;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const BirdImage = styled.img`
  width: 125%;
  height: 125%;
  object-fit: contain;
  padding: 15px;
  transition: all 300ms ease-out;

  &:hover {
    transform: scale(1.1);
  }
`; 